import React from 'react';
import {
  render as reactRender,
} from 'react-dom';
import {
  Provider,
} from 'react-redux';
import * as Sentry from '@sentry/browser';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';

import App from 'web-containers/AppContainer';
import config from 'web-config';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'draft-js/dist/Draft.css';

import './i18n';
import store from './store';
import pjson from '../package.json';

const env = process.env.TARGET_ENV;
if (env !== 'development') {
  Sentry.init({
    dsn: config.sentry.dsn,
    release: pjson.version,
    beforeSend(event: any, hint: any) {
      // eslint-disable-next-line
      const message = event.exception.values[0].value || hint.originalException.message;
      if (message && message.startsWith('Non-Error promise rejection captured')) {
        // We want to ignore those kind of errors
        return null;
      }
      return event;
    },
  });
}

if (env === 'production') {
  ReactPixel.init(config.facebook.pixel_id);
  TagManager.initialize({
    gtmId: config.gtm.account,
  });
}

const rootEl: HTMLElement | null = window.document.getElementById('root');

const render: Function = (Component: React.ComponentType<any>) => reactRender(
  <Provider store={store}>
    <Component />
  </Provider>,
  rootEl,
);

render(App);
